import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TableSettingsManager } from 'src/services/table-settings-service/table-settings-manager';
import type { UnitsSettingsStore } from 'src/services/units-settings-service';

import { DEFAULT_TABLE_HEADER_ORIENTATION, type TableHeaderOrientation } from '../../header-orientation';

import styles from './table-header.module.scss';

type Props = {
  textTKey: string;
  fieldId?: string;
  /** Explicit orientation override (e.g. group headers stay horizontal). */
  orientation?: TableHeaderOrientation;
  settingsManager?: TableSettingsManager | null;
  unitsSettingsStore?: UnitsSettingsStore;
};

export const TableHeader = wrap<Props>(function TableHeader({
  textTKey,
  fieldId,
  unitsSettingsStore,
  orientation: orientationOverride,
  settingsManager,
}) {
  const { t } = useTranslation();
  const orientation = orientationOverride ?? settingsManager?.headerOrientation ?? DEFAULT_TABLE_HEADER_ORIENTATION;
  const unit = fieldId ? unitsSettingsStore?.getUnitAbbreviation(fieldId) : null;

  return (
    <div
      className={clsx(styles.wrapper, orientation === 'vertical' && styles.vertical)}
      title={`${t(textTKey)}${unit ? `, ${unit}` : ''}`}
    >
      <h4 className={styles.header}>{t(textTKey)}</h4>
      {unit && <p className={styles.unit}>{`, ${unit}`}</p>}
    </div>
  );
});
